import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useUtilisationBarStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      border: `1px solid ${theme.palette.divider}`,
      position: 'relative',
      overflow: 'hidden',
      width: 100,
      height: 10,
      borderRadius: 2,
    },
    value: {
      lineHeight: '24px',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      fontWeight: '600',
    },
    bar: {
      height: '100%',
      '&.low': {
        backgroundColor: 'rgba(130,210,73, 0.49)',
      },
      '&.medium': {
        backgroundColor: 'rgba(130,210,73, 0.7)',
      },
      '&.high': {
        backgroundColor: 'rgba(130,210,73, 1)',
      },
    },
  })
);

export default useUtilisationBarStyles;
